import {colors} from '@commercial-helios/ui/theme'
import {css} from 'styled-components'

export const edgeGradient = (bgColor?: keyof typeof colors.background) => css`
    isolation: isolate;

    &::before,
    &::after {
        position: absolute;
        top: 0;
        width: 100px;
        height: 100%;
        content: '';
        background: linear-gradient(
            90deg,
            ${colors.background[bgColor || 'default']} 12%,
            rgb(255 255 255 / 0%) 100%
        );
    }

    &::before {
        left: 0;
        z-index: 1;
    }

    &::after {
        right: 0;
        transform: rotateZ(180deg);
    }
`
